<template>
  <div>
    <b-input-date
      v-model="deliveryData.deliveryDate"
      label="Дата доставки"
      :error-messages="getErrorMessages(v$.deliveryDate)"
      @blur="v$.deliveryDate.$touch()"></b-input-date>
  </div>
</template>

<script>
import { BInputDate } from 'best-modules/components'
import { urlCorrespondenceDelivered } from '@/utils/urls.js'
import { reactive } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { axios } from '@/plugins'
import { getErrorMessages } from 'best-modules/utils'

export default {
  name: 'CorrespondenceDeliver',
  components: { BInputDate },
  props: {
    dialog: {
      type: Object,
      required: true,
    },
  },
  methods: { getErrorMessages },
  setup(props) {
    const deliveryData = reactive({
      deliveryDate: null,
    })
    const rules = {
      deliveryDate: { required },
    }
    const v$ = useVuelidate(rules, deliveryData)

    const submit = () => {
      return axios.post(
        urlCorrespondenceDelivered(props.dialog.dialogData.correspondenceId),
        deliveryData
      )
    }

    return { deliveryData, v$, submit }
  },
}
</script>
